/**
 * Hook for validating CURP
 */
import { useMemo } from "react";
import { useSignup as useSignupContext } from "../../SignupContext";
import { handleApiError, InvalidStateError } from "../../utils/Errors";
import { useApiRequest } from "../../utils/useApiRequest";
/**
 * Hook for validating a CURP (Clave Única de Registro de Población)
 * @returns RequestState object for CURP validation
 */
export function useValidateCurp() {
    const { apiClient } = useSignupContext();
    const { state: validateCurpState, execute: executeValidateCurp, reset: resetValidateCurpState, } = useApiRequest();
    return useMemo(() => ({
        execute: async (curp) => {
            // Validate required fields
            if (!curp || curp.trim() === "") {
                throw new InvalidStateError("Cannot validate empty CURP", ["curp"]);
            }
            return executeValidateCurp(async (curpParam) => {
                const response = await apiClient.validateCurp(curpParam);
                if (response.ok) {
                    const data = await response.json();
                    return data;
                }
                else {
                    const error = await handleApiError(response);
                    throw error;
                }
            }, curp);
        },
        isLoading: validateCurpState.isLoading,
        error: validateCurpState.error,
        data: validateCurpState.data,
        reset: resetValidateCurpState,
    }), [apiClient, executeValidateCurp, validateCurpState, resetValidateCurpState]);
}
